import { useEffect, useRef } from "react";
import "pannellum/build/pannellum.css";
import "pannellum/build/pannellum.js";
import { mediaUrl } from "../lib/api";

export default function PanoramaViewer({ url, title }) {
  const el = useRef(null);
  useEffect(() => {
    if (!el.current || !window.pannellum) return undefined;
    const v = window.pannellum.viewer(el.current, { type: "equirectangular", panorama: mediaUrl(url), autoLoad: true, showControls: true, compass: false, title: "", autoRotate: -2 });
    return () => v?.destroy?.();
  }, [url]);
  return <div ref={el} data-testid="panorama-viewer" aria-label={title} className="aspect-video w-full overflow-hidden rounded-sm bg-overlay" />;
}
